import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AuthProvider from 'shared/contexts/AuthContext.tsx';
import { AppRouter } from './pages/router.tsx';

export const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language || 'pl');
  }, []);

  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
};
